import {GetterTree} from 'vuex';

import {RootState} from '@/store';
import {State} from './state';

export type Getters = {
    getApplyFilterLabel(state: State): string;
    getCloseFilterLabel(state: State): string;
    getOpenFilterLabel(state: State): string;
}

export const getters: GetterTree<State, RootState> & Getters = {
    getApplyFilterLabel: state => state.applyFilterLabel,
    getCloseFilterLabel: state => state.closeFilterLabel,
    getOpenFilterLabel: state => state.openFilterLabel,
};
